import { ResourceCardProps } from '@/components/_atoms/ResourceCard';
import ResourceCards from '@/components/_organisms/ResourceCards';
import { ModuleResourceCardsFragment } from '@/graphql';
import { getContentType } from '@/lib/craft-utils';
import gtm from '@/lib/gtm';
import { getSingle, maybeNotSet, notEmpty } from '@/lib/typescript-helpers';
import { FC } from 'react';

type ModuleProps = CraftModuleFragment<ModuleResourceCardsFragment>;

interface ResourceCardsModuleProps extends PropsWithClassName {
  props: ModuleProps;
}

const ResourceCardsModule: FC<ResourceCardsModuleProps> = ({ props, className }) => {
  if (Array.isArray(props)) {
    props = props[0];
  }

  if (!props) return null;

  return (
    <ResourceCards
      heading={props.heading ?? undefined}
      resources={
        props.resources
          .filter(notEmpty)
          .map((resource, index) => {
            if (!resource.title || !resource.url) return null;

            const image = getSingle(resource.coverImage);

            return {
              title: resource.title,
              eyebrow: getContentType(resource.__typename),
              href: resource.url,
              image: image?.url
                ? {
                    src: image.url,
                    alt: resource.title,
                  }
                : undefined,
              onClick: () => {
                gtm.track('click', {
                  card_position: `${index + 1}`,
                  element_label: 'Resource Card',
                  element_type: 'link',
                  location: 'Related Resources',
                  resource_title: maybeNotSet(resource.title),
                });
              },
            } satisfies ResourceCardProps;
          })
          .filter(notEmpty) ?? []
      }
    />
  );
};

export default ResourceCardsModule;

export function resourceCardsModuleHasCards(props: ModuleProps) {
  if (!props) return false;

  if (Array.isArray(props)) {
    props = props[0];
  }

  return (props?.resources ?? []).length > 0;
}
